<template>
  <div>
    <label class="formulate-input-label" style="margin:0;" for="valueGroup">{{label}}</label>
    <div id="valueGroup" style="display: flex; justify-content: space-between; gap: .5rem;">
      <NxInput
      name="dateInicial"
      type="date"
      placeholder="De:"
      :value="localInitialValue"
      @update:value="handleInitialValueUpdate"
      :max="getCurrentDate()"
    ></NxInput>
      <NxInput
      name="dateFinal"
      type="date"
      placeholder="Até:"
      :value="localFinalValue"
      @update:value="handleFinalValueUpdate"
      :max="getCurrentDate()"
    ></NxInput>
    </div>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputDateRange',
  mixins: [useReactiveModelMixin('InitialValue'), useReactiveModelMixin('FinalValue')],
  props: {
    label: {
      required: true,
      type: String,
      default: null
    }
  },
  methods: {
    // NEEDS TO MAP REPLACE - FOR / BEFORE SUBMITNG
    handleInitialValueUpdate (val) {
      this.localInitialValue = val
    },
    handleFinalValueUpdate (val) {
      this.localFinalValue = val
    },
    getCurrentDate () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0') // January is 0!
      let year = date.getFullYear()

      let currentDate = year + '-' + month + '-' + day

      return currentDate
    }
  }
}
</script>
<style lang="scss" scoped>
#valueGroup{
  .formulate-input{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDateRange.vue